var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 13,
    viewBox: "0 0 96 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.187988 12.6V0H4.59799L6.77599 10.98H7.09999L9.27799 0H13.688V12.6H11.384V1.746H11.06L8.89999 12.6H4.97599L2.81599 1.746H2.49199V12.6H0.187988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.061 12.6V0H25.161V2.16H19.437V5.166H24.657V7.326H19.437V10.44H25.269V12.6H17.061Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9438 12.6V2.16H27.2718V0H36.9918V2.16H33.3198V12.6H30.9438Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5857 12.6L40.8977 0H45.0377L48.3497 12.6H45.9017L45.2177 9.828H40.7177L40.0337 12.6H37.5857ZM41.2757 7.632H44.6597L43.1297 1.494H42.8057L41.2757 7.632Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8579 12.6V0H53.2339V10.44H58.9939V12.6H50.8579Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6138 12.6V0H69.7138V2.16H63.9898V5.166H69.2098V7.326H63.9898V10.44H69.8218V12.6H61.6138Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5806 12.6V0H77.0986L79.6006 10.98H79.9246V0H82.2646V12.6H77.7466L75.2446 1.62H74.9206V12.6H72.5806Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6392 12.6V0H89.9592C91.6512 0 92.9352 0.432 93.8112 1.296C94.6992 2.148 95.1432 3.42 95.1432 5.112V7.488C95.1432 9.18 94.6992 10.458 93.8112 11.322C92.9352 12.174 91.6512 12.6 89.9592 12.6H85.6392ZM88.0152 10.44H89.9952C90.9552 10.44 91.6572 10.188 92.1012 9.684C92.5452 9.18 92.7672 8.472 92.7672 7.56V5.04C92.7672 4.116 92.5452 3.408 92.1012 2.916C91.6572 2.412 90.9552 2.16 89.9952 2.16H88.0152V10.44Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLogo);
export default __webpack_public_path__ + "static/media/text-logo.a0d7f82a549d6a920c19f221bbae03dd.svg";
export { ForwardRef as ReactComponent };